import React from "react";
import { Alert, Button } from "react-bootstrap";

export const ObviousNotification = ({
    expanded,
    setExpanded,
    title,
    message,
    faIcon,
    link,
    alertVariant,
}) => {
    return (
        <Alert
            variant={alertVariant}
            className="mb-0 py-2"
            dismissible={true}
            onClose={() => setExpanded(false)}
            show={expanded}
        >
            <div className="d-flex align-items-center">
                <i className={`fa ${faIcon} mr-2`} style={{ fontSize: "1.2rem" }}></i>
                <strong>{title} </strong>
                <span className="ml-2">{message}</span>
                <Button variant="outline-primary" size="sm" className="ml-4" href={link}>
                    Alle anzeigen <i className="fa fa-arrow-right ml-1"></i>
                </Button>
            </div>
        </Alert>
    );
};
